import { Reveal } from '@/components/Reveal/Reveal';
import { Section } from '@/components/Section/Section';
import { HOME_ABOUT } from '@/dictionary/home';
import { HOME_ANCHORS, ROUTES } from '@/dictionary/routes';
import { Button } from '@mantine/core';
import { Link } from 'react-router-dom';
/* וידאו הרקע הוא departments-bg.mp4 — כך במקור, למרות שם הקובץ. */
import aboutBackgroundUrl from '/assets/departments-bg.mp4';
import classes from './AboutTeaserSection.module.css';

export function AboutTeaserSection() {
  return (
    <Section id={HOME_ANCHORS.about.slice(1)} backgroundVideoUrl={aboutBackgroundUrl}>
      <Reveal>
        <div className={classes.copy}>
          <p className={classes.kicker}>{HOME_ABOUT.kicker}</p>
          <h2 className={classes.title}>
            {HOME_ABOUT.titleLead} {HOME_ABOUT.titleSecond}
            <span className={classes.thin}>{HOME_ABOUT.titleThin}</span>
          </h2>

          <p>
            {HOME_ABOUT.paragraphs[0]}
            <strong>{HOME_ABOUT.strongWord}</strong>
          </p>
          <p>{HOME_ABOUT.afterStrong}</p>
          <p>
            {HOME_ABOUT.departmentsIntro} {HOME_ABOUT.departmentsBody}
          </p>
          <p>{HOME_ABOUT.values}</p>
          <p>
            {HOME_ABOUT.ctaLines.map((line) => (
              <span key={line}>{line} </span>
            ))}
          </p>

          <Button component={Link} to={ROUTES.about} className={classes.cta}>
            {HOME_ABOUT.ctaLabel}
          </Button>
        </div>
      </Reveal>
    </Section>
  );
}
